import React, { useMemo, useState } from 'react';
import {
  AdminContentContainer,
  AdminContentTitle,
  List,
  ListHeader,
  ListItem,
  ListCount,
  ListRole,
  ScrollableList,
  UserItem,
  ListDetails,
} from '../styles';

const UsersByRole = ({ allUsers }) => {
  const [expandedRole, setExpandedRole] = useState(null);

  // Mapeamento das roles para os nomes amigáveis
  const roleNames = {
    professor: 'Professor',
    worker: 'Trabalhador',
    user: 'Usuário comum',
    admin: 'Administrador',
  };

  const rolesData = useMemo(() => {
    if (!allUsers) return [];

    const sortNames = (users) => users
      .map(user => user.nome)
      .sort((a, b) => a.localeCompare(b, 'pt-BR', { sensitivity: 'base' }));

    return [
      {
        role: 'professor',
        names: sortNames(allUsers.professor.users),
        count: allUsers.professor.total,
      },
      {
        role: 'user',
        names: sortNames(allUsers.user.users),
        count: allUsers.user.total,
      },
      {
        role: 'admin',
        names: sortNames(allUsers.admin.users),
        count: allUsers.admin.total,
      },
      {
        role: 'worker',
        names: sortNames(allUsers.worker.users),
        count: allUsers.worker.total,
      },
    ];
  }, [allUsers]);

  const toggleRole = (role) => {
    setExpandedRole(prev => (prev === role ? null : role));
  };

  return (
    <AdminContentContainer>
      <AdminContentTitle>Quantidade de Usuários por Role</AdminContentTitle>
        <List>
          {rolesData.map(({ role, names, count }) => (
            <ListItem key={role}>
              <ListHeader onClick={() => toggleRole(role)}>
                <ListRole>{roleNames[role]}</ListRole> {/* Exibe o nome amigável da role */}
                <ListCount>{count} usuários</ListCount>
              </ListHeader>

              {expandedRole === role && (
                <ListDetails>
                  <ScrollableList>
                    {names.map((name, index) => (
                      <UserItem key={`${role}-${index}`}>{name}</UserItem>
                    ))}
                  </ScrollableList>
                </ListDetails>
              )}
            </ListItem>
          ))}
        </List>
    </AdminContentContainer>
  );
};

export default UsersByRole;
